import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=221c82ec&"
import script from "./planos.vue?vue&type=script&lang=js&"
export * from "./planos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports